<template>
  <div v-if="startup.instantClaimStatus === 'AVAILABLE'">
    <StickyBlock>
      <b-row class="p-16 border-top">
        <b-col class="d-flex align-items-center justify-content-end">
          <button class="btn px-60" @click="openClaimModal">
            <span v-if="!isLoading"> {{ buttonText }}</span>
            <b-spinner v-else small />
          </button>
        </b-col>
      </b-row>
    </StickyBlock>
    <ApplicationSentModal v-model="isClaimSubmittedModalOpen" :success-data="claimSuccessData" />
    <div v-if="isModalOpen">
      <StartupInstantClaimModal
        v-if="isLoggedIn"
        v-model="isModalOpen"
        :startup="startup"
        @submitted="onClaimSubmitted"
      />
      <!-- <AuthFlow
      v-if="modalAuthFlow.isVisible"
      :initial-route="modalAuthFlow.initialRoute"
      :disable-sign-up="modalAuthFlow.disableSignUp"
      :on-cancel="modalAuthFlow.onCancelCallback"
      :on-auth-success="modalAuthFlow.onAuthSuccessCallback"
      :defaults="modalAuthFlow.defaults"
    /> -->
      <AuthFlow
        v-else
        :initial-route="''"
        :disable-sign-up="false"
        :on-cancel="onClose"
        :on-auth-success="onSuccessSignIn"
        :defaults="{}"
        customSignUpModalTitle="Sign up to claim your startup profile"
      />
    </div>
  </div>
</template>

<script>
import StartupInstantClaimModal from '@/modals/startup/StartupInstantClaim';
import ApplicationSentModal from '@/modals/ApplicationSent';
import StickyBlock from '@/components/StickyBlock';
import AuthFlow from '@/components/auth-flow/index';

export default {
  name: 'StartupClaim',
  components: {
    ApplicationSentModal,
    StickyBlock,
    StartupInstantClaimModal,
    AuthFlow
  },
  props: {
    startup: {
      type: Object,
      required: true
    },
    buttonText: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      isLoggedIn: this.$store.getters['user/currentProfile'],
      claimSuccessData: null,
      isModalOpen: false,
      isClaimSubmittedModalOpen: false,
      claimSuccessData: {
        title: 'Startup is claimed successfully',
        subtitle: 'You will be redirected to the startup dashbord in a few seconds',
        image: 'paper-plane.svg',
        label: 'Close',
        width: '447'
      }
    };
  },
  computed: {
    userCurrentProfile() {
      return this.$store.getters['user/currentProfile'];
    },
    modalAuthFlow() {
      return this.$store.getters['modal/authFlow'];
    }
  },
  methods: {
    async onSuccessSignIn(params) {
      try {
        this.isLoading = true;
        this.isModalOpen = false;
        console.log('onSuccessSignIn 0');
        await this.$axios.post(`companies/${this.startup.key}/instantClaim`);
        // this.$router.push(`/client/startups/${this.startup.key}`);
        this.isLoading = false;
        this.onClaimSubmitted();
      } catch (error) {
        console.log('Error:', error);
        alert('Something went wrong');
      }
    },
    onClose() {
      this.isModalOpen = false;
    },
    openClaimModal() {
      this.isModalOpen = true;
    },
    onClaimSubmitted(successData) {
      // this.claimSuccessData = successData;
      this.isModalOpen = false;
      this.isClaimSubmittedModalOpen = true;
      this.$store.dispatch('user/loadCompanyProfile', { key: this.startup.key });
      setTimeout(() => {
        // this.$router.push(`/client/startups/${this.startup.key}`);
        location.href = `/client/startups/${this.startup.key}?afterClaim=true`;
      }, 3000);
    }
  }
};
</script>
